import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=d5542ce4&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=d5542ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5542ce4",
  null
  
)

export default component.exports